import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BlogListComponent } from "./blog-list/blog-list.component";
import { BlogDetailComponent } from "./blog-detail/blog-detail.component";
import { FeaturedPostsComponent } from "./featured-posts/featured-posts.component";
import { FeaturedSuccessStoryComponent } from "../ui/featured-success-story/featured-success-story.component";
import { RouterModule } from "@angular/router";
import { StrapiModule } from "../strapi/strapi.module";
import { SharedModule } from "../shared/shared.module";
import { TestimonialsSectionComponent } from "./testimonials-section/testimonials-section.component";

@NgModule({
  declarations: [
    BlogListComponent,
    BlogDetailComponent,
    FeaturedPostsComponent,
    FeaturedSuccessStoryComponent,
    TestimonialsSectionComponent,
  ],
  imports: [CommonModule, RouterModule, StrapiModule, SharedModule],
  exports: [
    BlogListComponent,
    BlogDetailComponent,
    FeaturedPostsComponent,
    FeaturedSuccessStoryComponent,
    TestimonialsSectionComponent,
  ],
})
export class BlogModule {}
